<template>
  <div >
 
        <div v-if="!$isMobile() || isMobile">
         
          <Motivos v-if="!datos.reclamo && !abriChat" :datos="datos" class="pv-options" />
          <EnEspera
            v-if="datos.reclamo && getArrepentido1()  && !abriChat"
            class="pv-options"
            :datos="datos"
          />
         <CommentSection v-if="(datos.reclamo && !getArrepentido1()) || abriChat" :datos="datos" :datosWc="datosWc" class="pv-options-1"/>
         <!-- <Motivos v-if="!cabecera" class="pv-options" />
        <-->
        </div>

        <el-button
          type="primary"
          size="default"
          class="btnAyuda hidden-sm-and-up"
          v-if="$isMobile() && !isMobile"
          @click="isMobile = true"
          >Ayuda con la compra</el-button
        >
        <el-button
          type="default"
          size="default"
          class="btnAyuda hidden-sm-and-up"
          v-if="$isMobile() && isMobile && mostrarVolver"
          @click="isMobile = false"
          >Volver al pedido</el-button
        >
     
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
import estadosMixins from "@/mixins/estadosMixins.js";

import Motivos from "@/components/motivos.vue";
import EnEspera from "@/components/EnEspera.vue";

import CommentSection from "@/components/commentSection.vue";
export default {
  props: ["datos"],
  mixins: [estadosMixins],
  name: "datosSection",
  components: {
 
    Motivos,
    EnEspera,
  
  
  
    CommentSection,
  
  },
  watch: {
    $route(to, from) {
      if (to.params.pedido != from.params.pedido) {
        this.pedido = to.params.pedido;
      }
    },
    	datos: function(newVal, oldVal) { // watch it
          this.datos = newVal;
        }
  },

  data() {
    return {
      isMobile:false,
      activeBtn: "pedido",
      reclamo: false,
      idwc: 0,
      abriChat: false,
      datosWc: {},
      mostrarVolver:false
    };
  },
  created() {
    this.getArrepentido1();
    EventBus.$on("goToMenu", (menu) => {
      this.activeBtn = menu;
    });
     EventBus.$on("abriChat", (datosWc) => {
       this.datosWc = datosWc
      this.abriChat = datosWc;
      this.mostrarVolver = false;
      
      console.log("abriChat");
    });

    EventBus.$on('regresarAlPedido', () => {
      this.isMobile = false;
        this.mostrarVolver = true;
      console.log('regresarAlPedido');
    });
    EventBus.$on("procesarArrepentimiento", (res) => {
      console.log("procesarArrepentimiento", res);
      if(res.reclamo.reclamo)
      {
  this.datos.datos_reclamo = res.reclamo.reclamo;
      this.datos.reclamo = res.reclamo.reclamo ? res.reclamo.reclamo[0].id : 0;
     
      }
      else
      {
        this.$alert("No pudimos procesar el reclamo, refresque la página y reintente", "Error", {
          confirmButtonText: "Aceptar",
        
        });
      }
       setTimeout(() => {
        this.getArrepentido1();
      }, 100);
    
    });
  },
  methods: {
    getArrepentido1() {
      if (
        this.datos.datos_reclamo &&
        this.datos.datos_reclamo.length &&
        [2, 3, 9, 6, 7, 8, 14, 21, 11, 12, 19, 10].includes(
          this.datos.datos_reclamo[0].motivo_id
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectMenu(menu) {
      this.activeBtn = menu;
      this.isMobile = false
    },
  },
};
</script>
<style lang="scss" scoped>

.botonera {
  background-color: #f0f0f0;
  padding: 15px 0px 20px 20px;
  border-radius: 8px 8px 0 0;
  padding-bottom: 0;
  transition: all 0.5s ease-in-out;
}
.botonera .el-button i {
  margin-right: 5px;
  // padding-left: 0;

  // float: left;
}

.botonera .el-button {
  border-radius: 0;
  border: none;
  font-family: 'Montserrat', sans-serif;
  //  text-align:left;
  font-size: 13.5px;
  // padding: 10px 0px;
  padding-bottom: 15px;
  padding-left: 0;
  background: transparent;
}
.is-active {
  border-bottom: 4px solid #BFBE51 !important;
  color: #333 !important;
  font-weight: bold;
}
.botonera .el-button + .el-button {
  margin-left: 0;
}
.menuTab {
}
@media screen and (max-width:768px) {
  .botonera .el-button {
  font-size: 12px;
  padding-bottom: 10px;
 
}
.botonera {
  
  padding: 0px 0px;
  padding-top: 10px;
  
}
}
</style>
